/**
 * Error Analytics API Service
 * 
 * Provides functions to interact with the error analytics endpoints
 */

import apiClient from '../services/api';
import { ErrorAnalytics, ErrorDetail } from '../types';

const normalizeErrorAnalytics = (data: any): ErrorAnalytics => ({
  ...data,
  error_types: data?.error_types || [],
  error_by_expert: data?.error_by_expert || data?.by_expert || [],
  error_by_system: data?.error_by_system || data?.by_system || [],
  error_by_agent: data?.error_by_agent || data?.agents?.breakdown || [],
  daily_trend: data?.daily_trend || [],
  recent_errors: data?.recent_errors || [],
});

export const errorAnalyticsApi = {
  /**
   * Get error analytics dashboard data
   */
  getDashboard: async (days: number = 30): Promise<ErrorAnalytics> => {
    const response = await apiClient.get<ErrorAnalytics>('/ai/expert/api/error-analytics/dashboard/', {
      params: { days }
    });
    return normalizeErrorAnalytics(response.data);
  },

  /**
   * Get detailed information about a specific error
   */
  getErrorDetail: async (errorId: string): Promise<ErrorDetail> => {
    const response = await apiClient.get<ErrorDetail>('/ai/expert/api/error-analytics/error_detail/', {
      params: { error_id: errorId }
    });
    return response.data;
  },
};

export default errorAnalyticsApi;
